var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-btn",
    _vm._b(
      {
        attrs: {
          "aria-label": _vm.$t("accessibility.aria.removeSeat"),
          "data-test": _vm.CypressTarget("Remove")
        },
        on: {
          click: function($event) {
            _vm.$emit("click")
          }
        }
      },
      "q-btn",
      _vm.quasarButtonProps,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }